import actions from './ThirdPartyActions';
import initialState from './ThirdPartyInitialState';
import reducers from './ThirdPartyReducer';

export default {
  actions,
  initialState,
  reducers,
};
